import React, {Component} from 'react';
import '../assets/css/script.css';
import '../assets/css/script_animation.css';
import ReactGA from 'react-ga';
import axios from "axios";
import {script_set} from '../assets/story_set';
import buzz from 'buzz';
import {calResult, API_URL, ADDY_URL} from '../config'
import Typist from "react-typist";

class Script extends Component {
    state = {
        health: 2,               // 초기 체력
        talk: 10,                 // 남은 대화 카운트
        beast_mask_step: 0,      // 야수가면 변경 단계
        gentle: 0,               // 온유
        flex: 0,                 // 융통
        forgive: 0,              // 관용
        patience: 0,             // 인내
        cur_script: "",
        script_load: false,
        next_id_set: ["0-0-0", "1-0-0", "2-0-0", "3-0-0", "4-0-0", "5-0-0"],
        mask_count: [0, 0, 0, 0],
        is_sound: false,
        is_opening: true,
        is_ending: false,
        horror_mask: "horror_mask mask_none",
        beast_mask: "beast_mask mask_none",
        beast_changed: false,
        is_change_first: false,
        royal_mask: "royal_mask mask_none",
        mystery_mask: "mystery_mask mask_none",
        eclin: "eclin mask_none",
    }
    chop_sound = new buzz.sound("https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_2/sound/chop-min.mp3");
    crash_sound = new buzz.sound("https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_2/sound/crash.mp3");
    punch_sound = new buzz.sound("https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_2/sound/punch.mp3");
    thunder_sound = new buzz.sound("https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_2/sound/thunder.mp3");
    boing_sound = new buzz.sound("https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_2/sound/boing.mp3");

    bgm;
    bgm_arr = [
        "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_2/sound/main-bgm.mp3",
        "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_2/sound/eclin-waltz-min.mp3"
    ]

    setBgm(index) {
        if (this.bgm) {
            if (this.state.is_sound) {
                this.bgm.fadeOut(2000).stop();
            }
            this.bgm = null;
        }
        this.bgm = new buzz.sound(this.bgm_arr[index])
    }

    async componentDidMount() {
        this.setBgm(0);
        this.soundToggle();
        this.setPageView('0');
        this.imagePreload();
        if (this.props.history.action === 'POP') {
            this.props.history.push('/')
        } else {
            await this.setState({cur_script: this.findScript(0)});
        }
    }

    async setBgmNull() {
        await this.bgm.stop();
        await this.thunder_sound.stop();
        this.bgm = null;
        this.thunder_sound = null;
    }

    imagePreload() {
        let images = [];
        let img_list = [
            'https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_2/mask/eklyn_0.png',
            'https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_2/mask/eklyn_1.png',
        ];

        for (let i = 0; i < img_list.length; i++) {
            images[i] = new Image();
            images[i].src = img_list[i];
        }

    }

    setLoad() {
        this.setState({script_load: true});
    }

    componentWillUnmount() {
        this.setBgmNull();
    }

    async nextScript(e, choice_index) {
        let {
            cur_script,
            talk,
            next_id_set,
            is_sound,
            is_ending,
            mask_count,
            gentle,
            patience,
            forgive,
            flex
        } = this.state;
        let target = cur_script.choice_set[choice_index].target;
        let {id, next_id, is_reset, is_result} = target;
        let script_load = false;
        if (is_sound) {
            this.chop_sound.stop();
            this.chop_sound.play();
        }

        if (id === '0-2-0') {
            await this.setState({is_opening: false});
        }

        if (cur_script.is_talk) {
            ReactGA.event({
                category: "Story-2 [가면테스트]",
                action: "Choice (SCENE-" + cur_script.id + ")",
                label: cur_script.choice_set[choice_index].title
            });
            mask_count[parseInt(cur_script.id.toString().split('-')[0]) - 1] += 1;
            talk -= 1;
        }
        // 엔딩 트리거
        // 체력소진 배드엔딩
        if (!is_ending && this.state.health === 0) {
            is_ending = true;
            id = '5-bad';
            if (is_sound) {
                this.crash_sound.play();
                this.thunder_sound.loop().play();
                this.bgm.stop();
            }
            await axios.get(
                ADDY_URL + '/api/v1/story/mask_fail/0',
                {
                    headers: {
                        'Authorization': "story_add_campus_312523"
                    }
                }
            );
            await ReactGA.event({
                category: "Story-2 [가면테스트]",
                action: "Result",
                label: "Bad Ending"
            });

            // 결과로 가기
        } else if (!is_ending && talk === 0 && !cur_script.is_talk) {
            is_ending = true;
            id = '5-0-0';
            await this.setBgm(1);
            if (is_sound) {
                this.bgm.loop().setVolume(0).fadeTo(25, 2000);
            }
        }

        await this.setEffect(cur_script.choice_set[choice_index].effect, cur_script.choice_set[choice_index].bg_effect);
        await this.setWeight(cur_script.choice_set[choice_index].weight, cur_script.choice_set[choice_index].tag_set);
        if (id !== cur_script.id) {
            if (id === '5-bad') {
                ReactGA.pageview('/mask/result/bad');
            } else {
                this.setPageView(cur_script.id.split('-')[0])
            }
        }

        if (is_result) {
            // 결과
            await this.setBgmNull();
            this.props.history.push('/result/' + calResult(gentle, flex, forgive, patience));
        } else if (is_reset) {
            // 다시하기
            await this.setBgmNull();
            this.props.history.push('/');

        } else {
            this.setMaskAnimation(id, cur_script.id, next_id);
            cur_script = this.findScript(id);
            if (next_id) {
                next_id_set[parseInt(next_id.split('-')[0])] = next_id
            }
            await this.setState({cur_script: ""});
            await this.setState({
                cur_script: cur_script,
                talk: talk,
                mask_count: mask_count,
                next_id_set: next_id_set,
                script_load: script_load,
                is_ending: is_ending,
            });
        }
    }

    async setWeight(weight, tag_set) {
        if (weight) {
            let {health, gentle, flex, forgive, patience, beast_mask_step} = this.state;
            if (weight.health) {
                health += weight.health;
                if (this.state.is_sound) {
                    this.punch_sound.setVolume(30).play();
                }
            }
            if (weight.gentle) {
                gentle += weight.gentle;
            }
            if (weight.flex) {
                flex += weight.flex;
            }
            if (weight.forgive) {
                forgive += weight.forgive;
            }
            if (weight.patience) {
                patience += weight.patience;
            }
            if (weight.beast_mask_step) {
                beast_mask_step += weight.beast_mask_step;
                if (this.state.is_sound) {
                    this.boing_sound.setVolume(50).play();
                }
                await this.setState({beast_changed: true, is_change_first: true});
                await this.setEffect('change_mask');
            }
            await this.setState({health, gentle, flex, forgive, patience, beast_mask_step})
        }
        if (tag_set) {
            for (let i = 0; i < tag_set.length; i++) {
                ReactGA.event({
                    category: "Story-2 [가면테스트]",
                    action: "Tag",
                    label: tag_set[i]
                });
            }
        }
        return true;
    }

    async setEffect(effect, bg_effect) {
        this.setState({effect: "", bg_effect: ""})
        if (effect) {
            this.setState({effect})
        }
        if (bg_effect) {
            this.setState({bg_effect})
        }
    }

    findScript(id) {
        let result;
        let idx = parseInt(id.toString().split('-')[0]);
        if (id.toString().length === 1) {
            id = this.state.next_id_set[idx];
        }

        for (let i = 0; i < script_set[idx].length; i++) {
            if (script_set[idx][i].id === id) {
                result = script_set[idx][i];
                break;
            }
        }
        return result
    }

    async soundToggle() {
        this.setState({is_sound: !this.state.is_sound}, () => {
            if (this.state.cur_script.id === '5-bad') {
                this.state.is_sound ? this.thunder_sound.play().loop() : this.thunder_sound.pause();
            } else {
                this.state.is_sound ? this.bgm.setVolume(0).play().loop().fadeTo(30, 3000) : this.bgm.pause();
            }
        })
    }

    setMaskAnimation(id, before_id, next_id) {
        let idx = parseInt(id.toString().split('-')[0]);
        let before_idx = parseInt(before_id.toString().split('-')[0]);
        let default_mask_classes = ["horror_mask", "beast_mask", "royal_mask", "mystery_mask", "eclin_bad mask_none"];
        let mask_classes = ["horror_mask", "beast_mask", "royal_mask", "mystery_mask", "eclin_bad"];
        for (let i = 0; i < mask_classes.length; i++) {
            if (idx > 0) {
                mask_classes[i] = default_mask_classes[i] + " mask_fade_out";
                mask_classes[idx - 1] = default_mask_classes[idx - 1] + " mask_center";
                if (before_idx && before_idx - 1 !== i) {
                    mask_classes[i] = default_mask_classes[i] + " mask_none";
                }
                if (before_idx && before_idx !== idx) {
                    mask_classes[idx - 1] = default_mask_classes[idx - 1] + " fade_mask_center"
                    mask_classes[before_idx - 1] = default_mask_classes[before_idx - 1] + " inter_mask"
                }
            } else {
                if (id === '0-select') {
                    mask_classes[before_idx - 1] = default_mask_classes[before_idx - 1] + " re_mask";
                } else if (id === '0-4-0' || id === '0-3-0') {
                    mask_classes[i] = default_mask_classes[i];
                } else {
                    mask_classes[i] = default_mask_classes[i] + " mask_none";
                }
            }
            if (idx === 5) {
                if (id !== '5-bad') {
                    mask_classes[4] = "eclin";
                }
            } else {
                mask_classes[4] = "eclin mask_none";
            }
        }

        if (this.state.beast_changed) {
            if (id === '0-select' || idx !== 2) {
                this.setState({beast_changed: false})
            } else {
                if (this.state.is_change_first) {
                    mask_classes[1] = "beast_mask change_mask";
                    this.setState({is_change_first: false});
                } else {
                    mask_classes[1] = "beast_mask only_center";
                }
            }
        }
        if (next_id === '4-end') {
            mask_classes[3] = "mystery_mask fade_out_re_mask"
        }
        if (this.state.next_id_set[4] === '4-end') {
            mask_classes[3] = "mystery_mask mask_none";
        }
        if (id === '5-bad') {
            mask_classes[4] = "eclin_bad";
            mask_classes = ["horror_mask mask_none", "beast_mask mask_none", "royal_mask mask_none", "mystery_mask mask_none", "eclin_bad"]
            this.setState({effect: 'eclin_bg_effect'})
        }
        this.setState({
            horror_mask: mask_classes[0],
            beast_mask: mask_classes[1],
            royal_mask: mask_classes[2],
            mystery_mask: mask_classes[3],
            eclin: mask_classes[4],
        });
    }

    setPageView(scene) {
        ReactGA.pageview('/mask/scene/' + scene);
    }

    render() {
        const {
            cur_script,
            script_load,
            is_sound,
            next_id_set,
            horror_mask,
            beast_mask,
            beast_mask_step,
            royal_mask,
            mystery_mask,
            eclin,
            effect,
            bg_effect,
            is_opening
        } = this.state;
        let choice_set;
        let talk_class = 'talk_box';
        if (cur_script && script_load) {
            let btn_top = 82 - cur_script.choice_set.length * 5.5;
            choice_set = <div className="btn_wrapper">
                {
                    cur_script.choice_set &&
                    cur_script.choice_set.map((choice, index) => {
                        let btn_style = {};
                        let btn_position = {
                            zIndex: 10,
                            top: btn_top + 'vh',
                            width: "90%",
                            margin: "10px auto"
                        };
                        if (cur_script.id === '0-select' && next_id_set[index + 1] === index + 1 + "-end") {
                            btn_style["background"] = "#2b2b2b";
                        }
                        if (cur_script.id === '0-select') {
                            btn_position["width"] = "48%";
                            btn_position['top'] = '70vh';
                            if (index % 2) {
                                btn_position['float'] = "left";
                                btn_style['marginLeft'] = "0";
                            } else {
                                btn_position['float'] = "right";
                                btn_style['marginRight'] = "0";
                            }
                        }
                        return (
                            <div key={index} className="relative_btn" style={btn_position}>
                                <button
                                    className={"text_btn"}
                                    key={index}
                                    style={btn_style}
                                    onClick={(e) => this.nextScript(e, index)}
                                >{choice.title}</button>
                            </div>
                        )
                    })
                }
            </div>
        }
        if (cur_script) {
            if (parseInt(cur_script.id.split('-')) !== 0) {
                talk_class = 'talk_bubble_box';
            }
            if (parseInt(cur_script.id.split('-')) === 2 || cur_script.id === "5-0-0" || cur_script.id === "5-bad") {
                talk_class = 'talk_box';
            }
        }

        let sound_icon = <img alt="sound_icon" onClick={() => this.soundToggle()} className="sound_icon"
                              draggable={false}
                              src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/icon/sound-off.svg"/>;
        if (is_sound) {
            sound_icon = <img alt="sound_icon" onClick={() => this.soundToggle()} className="sound_icon"
                              draggable={false}
                              src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/icon/sound-on.svg"/>
        }
        let intro_bg, eclin_light;
        let eclin_img = "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_2/mask/eklyn.png";
        let eclin_eye = "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_2/mask/apngb-animated.png";
        if (cur_script.id !== '0-0-0' && cur_script.id === '0-1-0') {
            intro_bg = <div className="black_background"/>;
        } else {
            intro_bg = <div className="black_background fade_out"/>;
            if (cur_script.id === '5-bad') {
                eclin_eye = "";
                eclin_img = "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_2/mask/eklyn_0.png";
                eclin_light = "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_2/mask/eklyn_1.png";
            }
        }
        let n_talk = 10 - this.state.talk;
        let select_title = '첫 번째 대화'
        if (n_talk > 0) {
            select_title = n_talk + 1 + ' 번째 대화'
        }
        if (cur_script.id === '0-select') {
            cur_script.title = select_title;
        }
        return (
            <div className="script fade_in">
                <div className={effect}/>
                <div className="main_background">
                    {
                        is_opening &&
                        <>
                            <img alt="castle" className="castle"
                                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_2/script/castle.png"/>
                            <img
                                className="bodyguard"
                                src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_2/script/bodyguard.png"
                                alt='bodyguard'/>
                        </>
                    }
                    {intro_bg}
                    <img className={"background_1 " + bg_effect} alt="bg" draggable="false"
                         src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_2/script/bg.jpg"/>
                    <img className={eclin} alt="eclin" draggable="false" src={eclin_img}/>
                    {
                        eclin_eye &&
                        <img className={eclin + " eye_eclin"} alt="eclin" draggable="false" src={eclin_eye}/>
                    }
                    {
                        eclin_light &&
                        <img className={eclin + " light_eclin"} alt="eclin" draggable="false" src={eclin_light}/>
                    }
                    <img className={horror_mask} alt="horror_mask" draggable="false"
                         src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_2/mask/horror.png"/>
                    <img className={beast_mask} alt="beast_mask" draggable="false"
                         src={'https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_2/mask/beast_' + beast_mask_step + '.png'}/>
                    <img className={royal_mask} alt="royal_mask" draggable="false"
                         src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_2/mask/royal.png"/>
                    <img className={mystery_mask} alt="mystery_mask" draggable="false"
                         src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_2/mask/mist.png"/>
                    <img alt="effect" className="light_body_1"
                         src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_2/script/light_body.png"/>
                    <img alt="effect" className="light_fire_1"
                         src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_2/script/light_fire.png"/>
                    <img alt="effect" className="light_body_2"
                         src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_2/script/light_body.png"/>
                    <img alt="effect" className="light_fire_2"
                         src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_2/script/light_fire.png"/>
                    <img alt="effect" className="light_body_3"
                         src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_2/script/light_body.png"/>
                    <img alt="effect" className="light_fire_3"
                         src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_2/script/light_fire.png"/>
                    <img alt="effect" className="desk_img" draggable="false"
                         src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_2/script/table.png"/>
                    {
                        effect === 'eye_light' &&
                        <img alt="effect" className="eye_light"
                             src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_2/mask/horro_effect.png"/>
                    }
                    <div className="wrapper">
                        {choice_set}
                    </div>
                </div>
                {
                    sound_icon
                }
                <div className="absolute_wrapper">
                    <div className="wrapper">
                        {cur_script &&
                        <div className={talk_class}>
                            <span className={"title " + cur_script.dom_animation}>{cur_script.title}</span>
                            <Typist cursor={{show: false, element: ''}}
                                    avgTypingDelay={40}
                                    onTypingDone={() => {
                                        this.setLoad();
                                    }}>
                                <span className="msg"
                                      style={{whiteSpace: 'pre-wrap'}}>{cur_script.msg}</span>
                            </Typist>
                        </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default Script;
